export function tryFocus(ref: React.RefObject<any>, attempts = 10) {
  if (!ref.current) return;

  ref.current.focus?.();

  if (attempts > 0) {
    setTimeout(() => {
      if (!ref.current?.isFocused?.()) {
        tryFocus(ref, attempts - 1);
      }
    }, 50);
  }
}
